import React, { memo, useEffect, useState } from "react";
import Hero from "./Hero";
import { BASE_URL } from "../../../../constant/apiUrl";
import Loading from "../../../../utils/Loader";
import { getAPI } from "../../../../API/ApiService";
import { useDispatch } from "react-redux";
import { setCarousalImage } from "../../../../slices/imageSlice";

function LandingSection() {
  const [loading, setLoading] = useState(true);
  const [fetchData, setFetchData] = useState(false);
  const [heroData, setHeroData] = useState(
    Array(5)
      .fill(null)
      .map((_, i) => ({
        images: [],
        formData: {},
        slotNumber: i + 1,
      }))
  );
  const [populateData, setPopulateData] = useState([]);
  const dispatch = useDispatch();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getAPI(
          `${BASE_URL}/administrative_landing/getAllSlots`
        );

        const fetched = Array.isArray(response?.data) ? response.data : [];

        // Map each slot number to the returned slot data
        const slotMap = fetched.reduce((acc, hero) => {
          if (hero.slotNumber >= 1 && hero.slotNumber <= 5) {
            acc[hero.slotNumber] = hero;
          }
          return acc;
        }, {});

        // Update heroData with CDN URLs
        setHeroData((prev) =>
          prev.map((slot) => ({
            ...slot,
            images: slotMap[slot.slotNumber]?.cdnUrl
              ? [{ preview: slotMap[slot.slotNumber].cdnUrl }]
              : [],

            formData: slotMap[slot.slotNumber] || slot.formData,
          }))
        );

        setPopulateData(
          fetched.filter((h) => h.slotNumber >= 1 && h.slotNumber <= 5)
        );
      } catch (error) {
        console.error("Failed to fetch landing data", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [fetchData]);

  const updateHeroData = (slotNumber, images) => {
    setHeroData((prev) =>
      prev.map((item) =>
        item.slotNumber === slotNumber ? { ...item, images } : item
      )
    );
  };

  if (loading) return <Loading />;

  return (
    <div className="flex flex-col gap-6">
      {heroData.map((hero) => (
        <Hero
          key={hero.slotNumber}
          images={hero.images}
          setHeroData={(images) => updateHeroData(hero.slotNumber, images)}
          populateData={populateData.find(
            (slot) => slot.slotNumber === hero.slotNumber
          )}
          slotNumber={hero.slotNumber}
          setFetchData={setFetchData}
          fetchData={fetchData}
        />
      ))}
    </div>
  );
}

export default memo(LandingSection);
